export default __webpack_public_path__ + "static/media/u_wdt_c_3_4.19eca337.mp3";